import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { LiveSessionCardService } from '../service';
import {
	createCard,
	createCardFailure,
	createCardSuccess,
	deleteCard,
	deleteCardFailure,
	deleteCardSuccess,
	getCards,
	getCardsFailure,
	getCardsSuccess,
	getCardToUpdate,
	getCardToUpdateFailure,
	getCardToUpdateSuccess,
	searchCards,
	setSearchCardsResult,
	updateCard,
	updateCardFailure,
	updateCardSuccess,
} from './slice';

function* getCardsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new LiveSessionCardService(globalApplicationContext);
		const data = yield service.getCards(action.payload);
		yield put(getCardsSuccess(data));
	} catch (e) {
		yield put(getCardsFailure(e));
		console.error(e);
	}
}

function* searchCardsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new LiveSessionCardService(globalApplicationContext);
		const data = yield service.searchCards(action.payload.searchKey);
		yield put(setSearchCardsResult({ cards: data }));
	} catch (e) {
		console.error(e);
	}
}

function* deleteCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new LiveSessionCardService(globalApplicationContext);
		yield service.deleteCard(action.payload.cardId);
		yield put(deleteCardSuccess({}));
		toast('CTA deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteCardFailure(e));
		console.error(e);
	}
}

function* createCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new LiveSessionCardService(globalApplicationContext);
		yield service.createCard(action.payload.card);
		yield put(createCardSuccess({}));
		toast('CTA created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createCardFailure({}));
	}
}

function* getCardToUpdateHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new LiveSessionCardService(globalApplicationContext);
		const data = yield service.getCard(action.payload.cardId);
		yield put(
			getCardToUpdateSuccess({
				card: data,
			}),
		);
	} catch (e) {
		yield put(getCardToUpdateFailure({}));
	}
}

function* updateCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new LiveSessionCardService(globalApplicationContext);
		yield service.updateCard(action.payload.card);
		yield put(updateCardSuccess({}));
		toast('CTA updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateCardFailure({}));
	}
}

export function* liveSessionCardSaga(): Generator<any, any, any> {
	yield all([takeEvery(getCards, getCardsHandler)]);
	yield all([takeEvery(searchCards, searchCardsHandler)]);
	yield all([takeEvery(deleteCard, deleteCardHandler)]);

	yield all([takeEvery(createCard, createCardHandler)]);
	yield all([takeEvery(getCardToUpdate, getCardToUpdateHandler)]);
	yield all([takeEvery(updateCard, updateCardHandler)]);
}
